import {
  ConnectNestPensionParams,
  ConnectNestPensionResponse,
  ConnectSmartPensionDraftResponse,
  ConnectSmartPensionParams,
  CreateCompanyDraftResponse,
  CreateCompanyParams,
  CreateCompanyResponse,
  GetCompanyDraftPensionStatusResponse,
} from '@nxsys/types/api/company';
import { GetBankListResponse } from '@nxsys/types/api/bank';
import axiosPublic from '../axiosPublic';
import { endPoints } from '../endpoints';

export const getCompanyDraftByTokenApi = async (
  token: string,
): Promise<CreateCompanyDraftResponse> => {
  const response = await axiosPublic.get(endPoints.publicDraft.get(token));
  return response.data;
};

export const updateCompanyDraftByTokenApi = async (
  token: string,
  params: { frontendData: Record<string, any> },
): Promise<CreateCompanyDraftResponse> => {
  const response = await axiosPublic.put(
    endPoints.publicDraft.update(token),
    params,
  );
  return response.data;
};

export const connectNestPensionPublicApi = async (
  token: string,
  params: ConnectNestPensionParams,
): Promise<ConnectNestPensionResponse> => {
  const response = await axiosPublic.post(
    endPoints.publicDraft.connectNest(token),
    params,
  );
  return response.data;
};

export const preAuthorizeSmartPensionPublicApi = async (
  token: string,
  params: ConnectSmartPensionParams,
): Promise<ConnectSmartPensionDraftResponse> => {
  const response = await axiosPublic.post(
    endPoints.publicDraft.preAuthorizeSmartPension(token),
    params,
  );
  return response.data;
};

export const getCompanyDraftPensionStatusPublicApi = async (
  token: string,
): Promise<GetCompanyDraftPensionStatusResponse> => {
  const response = await axiosPublic.get(
    endPoints.publicDraft.pensionStatus(token),
  );
  return response.data;
};

export const getCompanyDraftBankNamesApi = async (
  token: string,
): Promise<GetBankListResponse> => {
  const response = await axiosPublic.get(
    endPoints.publicDraft.bankNames(token),
  );
  return response.data;
};

export const submitCompanyDraftApi = async (
  token: string,
  payload: CreateCompanyParams,
): Promise<CreateCompanyResponse> => {
  const response = await axiosPublic.post(
    endPoints.publicDraft.submit(token),
    payload,
  );
  return response.data;
};
